<template>
  <v-dialog
    v-model="showDialog"
    scrollable
    max-width="1000px"
    v-on:change="dialogClose()"
  >
    <v-card>
      <v-card-title>
        <!--search section-->
        <v-layout wrap>
          <v-flex xs12 sm6 md3 ml-2>
            <v-text-field
              name="issueNo"
              label="Issue No"
              v-model="queryParams.issueNo"
              type="text"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md3 ml-2>
            <v-text-field
              name="remark"
              label="Description"
              v-model="queryParams.remark"
              type="text"
            ></v-text-field>
          </v-flex>
          <v-flex sm2>
            <v-btn outline color="primary" @click="onSearch"
              >Search<v-icon right>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-flex xs12 class="mt-1">
          <v-card>
            <v-data-table
              :headers="headers"
              :items="accountReceivableList"
              class="elevation-1"
              :loading="showListLoading"
              :total-items="totalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              :must-sort="true"
            >
              <template slot="items" slot-scope="props">
                <td>
                  {{ props.item.issueDateInMilliSeconds | formatMsDate }}
                </td>
                <td @click="setAccountReceivable(props.item)">
                  <a>{{ props.item.issueNo }}</a>
                </td>
                <td style="text-align: right">
                  {{ props.item.cashAmount | decFormat(6) }}
                </td>
                <td style="text-align: right">
                  {{ props.item.paidAmount | decFormat(6) }}
                </td>
                <td style="text-align: right">
                  {{ props.item.remainingAmount | decFormat(6) }}
                </td>
                <td>{{ props.item.remark }}</td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { AccountReceivable } from "../../models/model";
import { commonService } from "../../services/common-service";
import { accountReceivableService } from "../../services/account-receivable-service";

export default {
  props: [
    "showAdvancedARListDialog",
    "fromDate",
    "toDate",
    "customerId",
    "shopId",
  ],
  data: () => ({
    showListLoading: false,
    showDialog: false,
    accountReceivableList: [],
    accountReceivable: new AccountReceivable(),
    headers: [
      { text: "Issue Date", align: "left", value: "issue_date" },
      { text: "Issue No", align: "left", value: "issue_no" },
      { text: "Advanced Amount", sortable: false },
      { text: "Advanced Used Amount", sortable: false },
      { text: "Remaining Amount", sortable: false },
      { text: "Description", value: "remark" },
    ],
    rowsPerPageItems: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "issue_no",
      totalItems: 0,
    },
    totalRows: 0,
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      customerId: "",
      shopId: "",
      issueNo: "",
      remark: "",
    },
  }),
  watch: {
    showAdvancedARListDialog: function () {
      this.showDialog = !this.showDialog;
      this.onSearch();
    },
    pagination: {
      handler() {
        this.getCustomerAdvancedTypeAccountReceivableList();
      },
      deep: true,
    },
  },
  methods: {
    onSearch() {
      if (this.fromDate) {
        this.queryParams.fromDate = this.fromDate;
      }
      if (this.toDate) {
        this.queryParams.toDate = this.toDate;
      }
      if (this.customerId) {
        this.queryParams.customerId = this.customerId;
      }
      if (this.shopId) {
        this.queryParams.shopId = this.shopId;
      }
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getCustomerAdvancedTypeAccountReceivableList();
    },
    getCustomerAdvancedTypeAccountReceivableList() {
      this.accountReceivableList = [];
      if (this.queryParams.customerId && this.queryParams.shopId) {
        this.showListLoading = true;
        let order = this.pagination.descending ? "desc" : "asc";

        accountReceivableService
          .getUnpaidCustomerAdvancedTypeAccountReceivableList(
            this.queryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then((res) => {
            this.accountReceivableList = res.data.accountReceivableList;
            this.totalRows = res.data.totalElements;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      }
    },
    setAccountReceivable(accountReceivable) {
      this.accountReceivable = accountReceivable;
      this.$emit("changeAccountReceivable", this.accountReceivable);
    },
    dialogClose() {
      this.showDialog = !this.showDialog;
    },
  },
};
</script>
